import styled from 'styled-components';
import { FAMILY_FONT_PRIMARY, TITLE_SIZE_4, TITLE_SIZE_5 } from '../../const/text';
import { SECONDARY_COLOR, SECONDARY_COLOR_5 } from '../../const/color';
import { CloseIcon, DropIcon } from '../../const/icons';
import { isHexColorDark } from '../../utils/Color';
import { ColorPicker, Tooltip } from '../Global';
import { device } from '../../const/device';

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 33px 45px;
  //overflow: hidden;
  
  grid-template-columns: repeat(5, 1fr);
  @media (${device.tablet}) {
    grid-gap: 32px 34px;
    grid-template-columns: repeat(9, 1fr);
  }

  @media (${device.tabletM}) {
    grid-template-columns: repeat(7, 1fr);
  }

  @media (${device.tabletS}) {
    grid-template-columns: repeat(5, 1fr);
  }
  
  @media (${device.mobileL}) {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 5px 5px 20px;
    ${ColorPicker.Item} {
      flex: 0 0 auto;
    }

    &::-webkit-scrollbar {
      height:3px;
    }
  
    &::-webkit-scrollbar-thumb {
      background:${SECONDARY_COLOR};
    }
  }
`;

export const Item = styled.div`
  //grid-row: 1;
  //column-count: 5;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 36px;
  margin-bottom: 45px;
  
  @media (${device.tablet}) {
    justify-content: space-between;
    place-items: center;
    align-items:end;
  }
  @media (${device.mobileL}) {
    margin-bottom: 24px;
    height: 24px;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0;
  > button {
    margin-left: 16px;
  }
  
  @media (${device.tablet}) {
    display: none;
  }
`;
export const TitleContainer = styled.div<{ themeColor: string }>`
  font-size: ${TITLE_SIZE_4}px;
  line-height: 130%;
  color: ${ props => props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR };
  text-transform: uppercase;
  ${Tooltip.Container} {
    margin-left: 8px;
  }
  
  @media (${device.mobileL}) {
    font-size: ${TITLE_SIZE_5}px;
  }
`;
export const HelpTextContainer = styled.div<{padding?:number}>`
  padding: ${props => props.padding ? props.padding : 21}px;
  color: #000000;
`;

export const Group = styled.div`
  border-bottom: 1px solid rgba(225, 226, 227, 0.7);
  margin-bottom: 32px;
  padding-bottom: 29px;  
  margin-top: -7px;
  display: flex;
`;